<template>
  <el-form label-width="80px" :model="formData" ref="formData" :rules="rules">
    <!-- <el-form-item label="端口映射"> -->
      <div style="margin: 20px 0;width:25%;">
        <el-input placeholder="根据端口搜索" prefix-icon="el-icon-search" 
          v-model="keyValue"
          ></el-input>
          <!-- @change="filterListData" -->
      </div>
      
      <div v-for="(pm, index) in filterPortData" :key="index">
        <el-col :span="6">
          <el-form-item label="内网端口" 
            :prop="index+'_innerPort'" 
            :rules="rules.innerPort">
            <el-input v-model="pm.innerPort" type="number" min="0"></el-input>

          </el-form-item>
        </el-col>
        <el-col align="center" :span="2">
          <i class="el-icon-d-arrow-right"></i>
        </el-col>
        <el-col :span="6">
          <el-form-item label="外网端口" 
            :prop="index + '_outerPort'" 
            :rules="rules.outerPort">
            <el-input v-model="pm.outerPort" type="number" min="0"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="协议">
            <el-select v-model="pm.protocol">
              <el-option :value="0" label="TCP/UDP"></el-option>
              <el-option :value="1" label="TCP"></el-option>
              <el-option :value="2" label="UDP"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon">
          <div class="el-icon-circle-plus" @click="addMap(index)"></div>
        </el-col>
        <el-col align="center" :span="2" class="operateIcon" v-if="filterPortData.length > 1">
          <div class="el-icon-delete-solid" @click="delMap(index)"></div>
        </el-col>
      </div>

      <div style="clear: both;text-align: center;">
        <el-button type="primary" size="mini" v-if="pageno != totalPage" @click="more()">查看更多</el-button>
      </div>
    <!-- </el-form-item> -->
    
  </el-form>
</template>

<script>
export default {
  name: "PortMap",
  props: {
    networkCard: {
      type: Object,
      required: true,
      default: {}
    }
  },
  data() {
    let validInnerPort = (rule, value, callback) => {
      if(!rule.field){
        return
      }
      // const index = rule.field.substring(0, 1)
      // const key = rule.field.substring(1)
      const index = rule.field.split("_")[0]
      const key = rule.field.split("_")[1]
      const port = this.filterPortData[index][key]
      const ports = this.formData.innerNetwork.ports
      const range = this.formData.innerNetwork.portRange
      const isexist = ports.some(p => Number(p.value) == Number(port))
      if(!isexist){
        const rangeExist = range.some(r => Number(port)>=Number(r.start) && Number(port)<=Number(r.end))
        if(!rangeExist){
          callback(new Error('端口号不在范围之内'))
        }else{
          callback()
        }
      }else{
        callback()
      }
    }
    let validOuterPort = (rule, value, callback) => {
      if(!rule.field){
        return
      }
      // const index = rule.field.substring(0, 1)
      // const key = rule.field.substring(1)
      const index = rule.field.split("_")[0]
      const key = rule.field.split("_")[1]
      const port = this.filterPortData[index][key]
      // const port = value
      const ports = this.formData.outerNetwork.ports
      const range = this.formData.outerNetwork.portRange
      const isexist = ports.some(p => Number(p.value) == Number(port))
      if(!isexist){
        const rangeExist = range.some(r => Number(port)>=Number(r.start) && Number(port)<=Number(r.end))
        if(!rangeExist){
          callback(new Error('端口号不在范围之内'))
        }else{
          callback()
        }
      }else{
        callback()
      }
    }
    return {
      formData: {
        portMap: [],
        listData: [],        
      },
      rules: {
        innerPort: [
          // { required: true, message: '端口号不能为空', trigger: 'blur' },
          { validator: validInnerPort, trigger: 'blur' }
        ],
        outerPort: [
          // { required: true, message: '端口号不能为空', trigger: 'blur' },
          { validator: validOuterPort, trigger: 'blur' }
        ],
      },
      pageno: 1, //当前了几页
      pagesize: 10,
      keyValue: '',
      portData: [], //当前显示的端口，点击查看更多，追加一页数据
    };
  },
  created() {
    this.formData = Object.assign({}, this.networkCard)
    this.getListData()
  },
  watch: {
    networkCard: {
      handler (newVal, oldVal) {
        this.pageno = 1
        let data = newVal
        if(newVal.portMap.length == 0){
          // data.portMap = [{innerPort: '', outerPort: '', protocol:0}]
        }
        this.formData = data
        this.getListData()
      },
      deep: true //是否深度监听
    },
  },
  computed: {
    totalPage(){
      let arr = []
      if(this.keyValue){
        arr = this.formData.portMap.filter(ld => ld.innerPort == this.keyValue || ld.outerPort == this.keyValue)
      }else{
        arr = this.formData.portMap
      }

      if(arr.length <= 10){
        return 1
      }
      const r = arr.length % this.pagesize
      const n = parseInt(arr.length / this.pagesize)
      if(r > 0){
        return (n+1)
      }else{
        return n
      }      
    },
    filterPortData(){
      let arr = []
      if(this.keyValue){
        arr = this.formData.portMap.filter(ld => ld.innerPort == this.keyValue || ld.outerPort == this.keyValue)
      }else{
        arr = this.portData
      }
      
      return arr
    }
  },
  methods: {
    more(){
      this.pageno++;
      let start = (this.pageno-1)* this.pagesize
      let end = (this.pageno-1)* this.pagesize + this.pagesize
      let arr = this.formData.portMap.slice(start, end)
      this.portData = this.portData.concat(arr)
    },
    getListData(){
      let arr = []
      if(this.totalPage > 1){
        arr = this.formData.portMap.slice(0, this.pagesize)
      }else {
        arr = this.formData.portMap
      }
      this.portData = arr      
    },
    
    addMap(index) {
      this.portData.splice(index+1, 0, {
        innerPort: "",
        outerPort: "",
        protocol: 0
      })
    },
    delMap(index) {
      this.portData.splice(index, 1);
    },
  }
};
</script>

<style scoped>
.operateIcon {
  cursor: pointer;
}
</style>
